import React from 'react';
import { WorkerFunctionEmbeddedPanel } from './worker-function-detail-embedded';
import { IWorkerFunctionDetailProps } from './worker-function-detail.types';

/**
 * Timeline detail for a worker function execution: the script that ran and the before/after claim
 * diff. Used by both Provider and Support apps, like `CodingDetail`.
 */
export const WorkerFunctionDetail: React.FunctionComponent<IWorkerFunctionDetailProps> = ({
    embedded = true,
    workerFunction,
}) => <WorkerFunctionEmbeddedPanel workerFunction={workerFunction} embedded={embedded} />;
